import RtlEmotionCacheProvider from './RtlEmotionCacheProvider';
export default RtlEmotionCacheProvider;